<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ShippingMethodTransportationList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingMethodTransportationList from "@/components/settings/test-registers/shippingmethodtransportation/ShippingMethodTransportationList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "ShippingMethodTransportationView",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ShippingMethodTransportationList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addshippingmethodtransportation" });
    },
  },
};
</script>
